
import Input from "../../../../common/input/Input";

export default function FieldText({ text, onChange }) {
	return (
		<>
			<Input
				onChange={onChange}
				value={text}
				label={"متن"}
				placeholder={""}
			/>
		</>
	)
}
